// frontend/modules/template/components/NotificationsLayout.tsx
import React from 'react';
import { Layout } from 'antd';
import { NotificationsSidebar } from './NotificationsSidebar';
import { Outlet } from 'react-router-dom';

const { Sider, Content } = Layout;

export const NotificationsLayout: React.FC = () => {
    return (
        <Layout style={{ minHeight: '100%' }}>
            <Sider width={220} theme="light" style={{ background: '#fff' }}>
                <NotificationsSidebar />
            </Sider>
            <Content style={{ padding: '24px', background: '#fff' }}>
                <Outlet />
            </Content>
        </Layout>
    );
};
